"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStartedEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Record_1 = require("../../utils/Record");
let Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStartedEventHandlerScript = class Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        let allyEffects = container.readLocal(event.subject, "DramaticEndings_AllyEffectIds", {});
        switch (event.args.__type) {
            case EventType_1.EventType.AllyKilled: {
                const effectIds = (0, Record_1.getValueOrDefaultTo)(allyEffects, event.args.allyId, []);
                effectIds.push(container.applyBuff({
                    sequence,
                    creatorId: event.subject,
                    targetId: event.subject,
                    effect: new __1.DramaticEndingsEffectArgs(container.getPercentOfBaseHealth(event.subject, 5), container.getPercentOfBaseAttributeScore(event.subject, 10, "Power")),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                }));
                container.setLocal(event.subject, "DramaticEndings_AllyEffectIds", allyEffects);
                break;
            }
            case EventType_1.EventType.AllyResurrected: {
                sequence = sequence.pushSequence("parallel");
                (0, Record_1.getValueOrDefaultTo)(allyEffects, event.args.allyId, []).forEach(effectId => container.cancelEffect(sequence, effectId));
                (0, Record_1.unsetValue)(allyEffects, event.args.allyId);
                container.setLocal(event.subject, "DramaticEndings_AllyEffectIds", allyEffects);
                break;
            }
            case EventType_1.EventType.TurnStarted: {
                sequence = sequence.pushSequence("parallel");
                container.selectTargets(event.subject, Target_1.Target.AllAllies)
                    .filter(actorId => container.isDeceased(actorId))
                    .forEach(actorId => {
                    const effectIds = (0, Record_1.getValueOrDefaultTo)(allyEffects, actorId, []);
                    effectIds.push(container.applyBuff({
                        creatorId: event.subject,
                        targetId: event.subject,
                        effect: new __1.DramaticEndingsEffectArgs(container.getPercentOfBaseHealth(event.subject, 5), container.getPercentOfBaseAttributeScore(event.subject, 10, "Power")),
                        duration: Duration_1.Duration.Permanent,
                        supernatural: true,
                        sequence
                    }));
                });
                container.setLocal(event.subject, "DramaticEndings_AllyEffectIds", allyEffects);
                break;
            }
        }
    }
};
Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStarted")
], Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStartedEventHandlerScript);
exports.Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStartedEventHandlerScript = Effect_DramaticEndings_OnAllyKilledOrAllyResurrectedOrTurnStartedEventHandlerScript;
